function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.0466 12.9238C15.0466 11.2168 16.4304 9.83298 18.1374 9.83298H26.4438C28.1508 9.83298 29.5346 11.2168 29.5346 12.9238V26.0595C29.5346 27.7665 28.1508 29.1503 26.4438 29.1503H18.1374C16.4304 29.1503 15.0466 27.7665 15.0466 26.0595V12.9238Z",
  fill: "#FD7E50"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M47.6929 14.6623C49.3999 14.6623 50.7836 16.0461 50.7836 17.7531V26.0595C50.7836 27.7665 49.3999 29.1503 47.6929 29.1503H34.5571C32.8501 29.1503 31.4663 27.7665 31.4663 26.0595V17.7531C31.4663 16.0461 32.8501 14.6623 34.5571 14.6623L47.6929 14.6623Z",
  fill: "#FD7E50"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.4438 31.082C28.1508 31.082 29.5346 32.4658 29.5346 34.1728V42.4793C29.5346 44.1863 28.1508 45.57 26.4438 45.57H13.308C11.601 45.57 10.2173 44.1863 10.2173 42.4793V34.1728C10.2173 32.4658 11.601 31.082 13.308 31.082H26.4438Z",
  fill: "#FD7E50"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M45.9543 47.3086C45.9543 49.0156 44.5705 50.3994 42.8635 50.3994H34.5571C32.8501 50.3994 31.4663 49.0156 31.4663 47.3086L31.4663 34.1728C31.4663 32.4658 32.8501 31.082 34.5571 31.082H42.8635C44.5705 31.082 45.9543 32.4658 45.9543 34.1728L45.9543 47.3086Z",
  fill: "#FD7E50"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M60.4423 22.0029C60.4423 24.1366 58.7126 25.8664 56.5788 25.8664C54.4451 25.8664 52.7154 24.1366 52.7154 22.0029C52.7154 19.8692 54.4451 18.1394 56.5788 18.1394C58.7126 18.1394 60.4423 19.8692 60.4423 22.0029Z",
  fill: "#FD7E50"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M26.2506 4.03778C26.2506 6.17152 24.5209 7.90125 22.3872 7.90125C20.2534 7.90125 18.5237 6.17152 18.5237 4.03778C18.5237 1.90405 20.2534 0.174316 22.3872 0.174316C24.5209 0.174316 26.2506 1.90405 26.2506 4.03778Z",
  fill: "#FD7E50"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M42.6704 56.1946C42.6704 58.3283 40.9406 60.058 38.8069 60.058C36.6732 60.058 34.9434 58.3283 34.9434 56.1946C34.9434 54.0608 36.6732 52.3311 38.8069 52.3311C40.9406 52.3311 42.6704 54.0608 42.6704 56.1946Z",
  fill: "#FD7E50"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M8.28553 38.4226C8.28553 40.5564 6.55579 42.2861 4.42206 42.2861C2.28833 42.2861 0.558594 40.5564 0.558594 38.4226C0.558594 36.2889 2.28833 34.5592 4.42206 34.5592C6.55579 34.5592 8.28553 36.2889 8.28553 38.4226Z",
  fill: "#FD7E50"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.950836a7.svg";
export { ForwardRef as ReactComponent };